import { render } from "./DonorQuestionnaireTab.vue?vue&type=template&id=4af04cc5"
import script from "./DonorQuestionnaireTab.vue?vue&type=script&lang=js"
export * from "./DonorQuestionnaireTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__